import type { IconSvgObject } from './types';

const CheckUnread03Icon: IconSvgObject = [
  ["path", { d: "M5 14L8.5 17.5L12.8953 12.8953M19 6.5L14.8488 10.8488", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 5L19 19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CheckUnread03Icon;
